import { Deserializable, JsonObject, Serializable } from '@ktypes/models';

export class Streak implements Deserializable<any, Streak>, Serializable<JsonObject> {
  constructor(public longest?: number, public current?: number) {}

  deserialize(input: any): Streak {
    if (input == null) {
      return null;
    }

    this.longest = input['max_streak'];
    this.current = input['current_streak'];
    return this;
  }

  serialize(): JsonObject {
    const json: JsonObject = {};
    json['max_streak'] = this.longest;
    json['current_streak'] = this.current;

    return json;
  }
}
